import { render } from "./ProductsGrid.vue?vue&type=template&id=5389981c&scoped=true"
import script from "./ProductsGrid.vue?vue&type=script&lang=js"
export * from "./ProductsGrid.vue?vue&type=script&lang=js"

import "./ProductsGrid.vue?vue&type=style&index=0&id=5389981c&lang=scss&scoped=true"

import exportComponent from "/Users/mmessick/Sites/kiosk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5389981c"]])

export default __exports__